// Projects shown at the bottom of the home page, grouped and filterable.
// `group` must match a key in PROJECT_GROUPS below.

import calhacks from '../assets/covers/calhacks.jpg';
import hackmit from '../assets/covers/hackmit.jpg';
import makeuoft from '../assets/covers/makeuoft.jpg';
import uoftHacksXI from '../assets/covers/uoftHacksXI.jpg';
import hackthe6ix from '../assets/covers/hackthe6ix.jpg';
import uoftHacks from '../assets/covers/uoftHacks.jpg';

import gokart from '../assets/covers/gokart.jpg';
import planes from '../assets/covers/planes.jpg';
import piLaptop from '../assets/covers/piLaptop.jpg';
import plant from '../assets/covers/plant.jpg';
import sanitizer from '../assets/covers/sanitizer.jpg';
import marketalarm from '../assets/covers/marketalarm.jpg';

import frc4627 from '../assets/covers/frc4627.jpg';
import openmv from '../assets/covers/openmv.jpg';
import toyota2023 from '../assets/covers/toyota2023.jpg';
import toyota from '../assets/covers/toyota.jpg';
import robot1a from '../assets/covers/robot1a.jpg';

export const PROJECT_GROUPS = [
  { id: 'hackathon', label: 'Hackathons',            blurb: 'Weekend builds, mostly hardware, occasionally award-winning.' },
  { id: 'personal',  label: 'Personal Builds',       blurb: 'Things I made because I wanted them to exist.' },
  { id: 'robotics',  label: 'Robotics & Competition', blurb: 'Competition robots, vision systems and coursework.' },
];

const projects = [
  // ---- Hackathons ----
  {
    id: 'calhacks', title: 'PulseWalk', event: 'Cal Hacks 11.0', year: 2024,
    group: 'hackathon', route: '/calhacks', cover: calhacks,
    blurb: 'A wearable that turns IR ranging into haptic feedback, giving your foot a sixth sense.',
    stack: ['ESP32', 'C++', 'BLE', 'Servos'], award: 'Best Hardware Hack',
  },
  {
    id: 'hackmit', title: 'Axy', event: 'HackMIT', year: 2024,
    group: 'hackathon', route: '/hackmit', cover: hackmit,
    blurb: 'Wearable stress detection from IMU and heart-rate signals, with AI insights.',
    stack: ['ESP8266', 'MPU6050', 'Convex', 'React'],
  },
  {
    id: 'makeuoft', title: 'Blind Watchers', event: 'MakeUofT', year: 2024,
    group: 'hackathon', route: '/makeuoft', cover: makeuoft,
    blurb: 'A hat with two cameras and spatial audio that narrates objects for the visually impaired.',
    stack: ['Jetson Nano', 'Python', 'Speech-to-Text'],
  },
  {
    id: 'uofthacksXI', title: 'StuDining', event: 'UofTHacks XI', year: 2024,
    group: 'hackathon', route: '/uofthacksXI', cover: uoftHacksXI,
    blurb: 'Lecture recorder and transcript chatbot with a tunable parental-advisory persona.',
    stack: ['Next.js', 'Django', 'Cohere', 'Google Cloud'],
  },
  {
    id: 'hackthe6ix', title: 'Professor Puddles', event: 'Hack the 6ix', year: 2023,
    group: 'hackathon', route: '/hackthe6ix', cover: hackthe6ix,
    blurb: 'A rubber duck that sprays you when your posture slips. Won first, out of 219.',
    stack: ['Python', 'OpenCV', 'MediaPipe', 'Tkinter'], award: '1st place · 219 participants',
  },
  {
    id: 'uofthacksX', title: 'BeRealocated', event: 'UofTHacks X', year: 2023,
    group: 'hackathon', route: '/uofthacksX', cover: uoftHacks,
    blurb: 'My first hackathon: a location-sharing app built in a weekend.',
    stack: ['React', 'Firebase', 'Google Cloud'],
  },

  // ---- Personal builds ----
  {
    id: 'gokart', title: 'Electric Go-kart', year: 2018,
    group: 'personal', route: '/gokart', cover: gokart,
    blurb: 'Welded frame, brushless drivetrain, built at 15 in a junior engineering club.',
    stack: ['Welding', 'Brushless Drive', 'Fabrication'],
  },
  {
    id: 'rcplanes', title: 'RC Planes', year: '2014 - 2020',
    group: 'personal', route: '/rcplanes', cover: planes,
    blurb: 'Six years of scratch-built airframes, each one flying a little longer than the last.',
    stack: ['Aerodynamics', 'Composites', 'Electronics'],
  },
  {
    id: 'RPilaptop', title: 'Raspberry Pi Laptop', year: 2022,
    group: 'personal', route: '/RPilaptop', cover: piLaptop,
    blurb: 'A hand-built portable Linux machine in a custom enclosure.',
    stack: ['Raspberry Pi', 'Linux', 'CAD'],
  },
  {
    id: 'plant', title: 'Automatic Plant Watering', year: 2021,
    group: 'personal', route: '/plant', cover: plant,
    blurb: 'Soil-moisture sensing and a peristaltic pump so I stop killing plants.',
    stack: ['Arduino', 'Sensors', 'C++'],
  },
  {
    id: 'sanitizer', title: 'Touchless Hand Sanitizer', year: 2020,
    group: 'personal', route: '/sanitizer', cover: sanitizer,
    blurb: 'IR-triggered dispenser, designed and printed during lockdown.',
    stack: ['Arduino', 'IR Sensing', '3D Printing'],
  },
  {
    id: 'marketalarm', title: 'Market Alarm', year: 2022,
    group: 'personal', route: '/marketalarm', cover: marketalarm,
    blurb: 'A price-watch alarm that wakes you when a ticker crosses your threshold.',
    stack: ['Python', 'APIs'],
  },

  // ---- Robotics & competition ----
  {
    id: 'frc4627', title: 'FRC 4627 Competition Robot', year: 2022,
    group: 'robotics', route: '/frc4627', cover: frc4627,
    blurb: 'Team captain. Java robot code, PID loops, and a MicroPython vision pipeline.',
    stack: ['Java', 'MicroPython', 'PID', 'OpenMV'],
  },
  {
    id: 'openmv', title: 'OpenMV Strategic Color Tracking', year: 2021,
    group: 'robotics', route: '/openmv', cover: openmv,
    blurb: 'On-camera ball tracking feeding targeting data to the robot over a JSON link.',
    stack: ['MicroPython', 'OpenMV', 'Computer Vision'],
  },
  {
    id: 'toyotainnovation2023', title: 'Toyota Innovation Challenge', year: 2023,
    group: 'robotics', route: '/toyotainnovation2023', cover: toyota2023,
    blurb: 'Real-time sticker placement verification to 3 mm. Won a prize at TMMC.',
    stack: ['Python', 'OpenCV'], award: 'Prize winner',
  },
  {
    id: 'toyotainnovation', title: 'Toyota Innovation Challenge', year: 2022,
    group: 'robotics', route: '/toyotainnovation', cover: toyota,
    blurb: 'Vision tracking for three model car variants, plus track and start/end detection.',
    stack: ['Python', 'OpenCV'],
  },
  {
    id: '1afinalproject', title: 'Autonomous Cube Collector', event: 'Mechatronics 1A', year: 2022,
    group: 'robotics', route: '/1afinalproject', cover: robot1a,
    blurb: 'First-term design project: an autonomous robot that finds and collects cubes.',
    stack: ['C++', 'Sensors', 'Mechanical Design'],
  },
];

export default projects;
